import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55eb8f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_regist_error_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"entry_base_title\" data-v-55eb8f40>ログインできません</h1><p class=\"entry_base_text\" data-v-55eb8f40><span class=\"entry_base_text_clause\" data-v-55eb8f40>過去にマスメディアンの転職サービスを利用し、</span><span class=\"entry_base_text_clause\" data-v-55eb8f40>現在利用を停止している可能性があります</span><br data-v-55eb8f40><span class=\"entry_base_text_clause\" data-v-55eb8f40>「転職支援サービスを再開する」ボタンをクリックし、お手続きください</span></p>", 2)
const _hoisted_4 = { class: "entry_base_button" }

import { useRouter } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginErrorForRestartAccount',
  setup(__props) {

const router = useRouter();

const transitionRestartAccountPage = () => {
  router.push({ name: 'q01'});
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          onClick: transitionRestartAccountPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("転職支援サービスを再開する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})